'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'fish-bones';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e304';
var svgPathData = 'M76.2 240l-38-101.5 57.9 38.6 0-38.5-64-42.7-32 32 48 128-48 128 32 32 64-42.7 0-38.5-57.9 38.6 38-101.5 67.8 0 0 96 32 0 0-96 64 0 0 96 32 0 0-96 64 0 0 96 32 0 0-96 48 0 0 128 32 0 128-144-128-144-32 0 0 128-48 0 0-96-32 0 0 96-64 0 0-96-32 0 0 96-64 0 0-96-32 0 0 96-67.8 0zM448 351.8l0-191.7 85.2 95.8-85.2 95.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFishBones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;